import { sqliteTable, text, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// overtime_requests — ขอล่วงเวลา (Overtime Request)
// ============================================================================
export const overtimeRequests = sqliteTable("hr_overtime_requests", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  employeeId: text("employee_id").notNull(),
  date: text("date").notNull(), // YYYY-MM-DD
  hours: real("hours").notNull(),
  reason: text("reason"),
  otType: text("ot_type").notNull().default("weekday"), // weekday, holiday
  otRate: real("ot_rate").notNull().default(1.5), // 1.5x weekday, 3x holiday
  status: text("status").notNull().default("pending"), // pending, approved, rejected
  approvedBy: text("approved_by"),
  approvedAt: text("approved_at"),
  rejectionReason: text("rejection_reason"),
  // Audit columns
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  ot_company_idx: index("ot_company_idx").on(table.companyId, table.status),
  ot_employee_idx: index("ot_employee_idx").on(table.companyId, table.employeeId),
}));

// Type exports
export type OvertimeRequest = typeof overtimeRequests.$inferSelect;
export type NewOvertimeRequest = typeof overtimeRequests.$inferInsert;
